<app-header></app-header>
<div class="responsive">
    <div class="container-fluid">
        <div class="row">
            <div class="col-md-3">
                <app-sidebar></app-sidebar>
            </div>
            <div class="col-md-6">
                <app-sub-header title="Photo Gallery"></app-sub-header>

                <div class="margin-b" style="text-align: end;">
                    <button routerLink='/photo-gallery/add-photo-gallery' class="btn  main-backgroundcolor color">Edit Gallery
                    </button>
                </div>

                <div style="min-height: 500px;">
                    <app-no-results-found *ngIf="objArr.length == 0 " title='Photo Gallery'>
                    </app-no-results-found>
                    <div class="display">
                        <div class="profile-image" style="position: relative; margin:22px;"
                            *ngFor="let props of objArr; let i = index">
                            <div class="position-2 cursor" (click)="deleteImages(i)"> <i
                                    class="fas fa-times-circle"></i></div>
                            <div *ngIf="deletingIndex === i" class="spinner-border text-muted"
                                style="position:absolute; top:40%; left:40%;"></div>

                            <div class="image-wrapper" style="width: 150px; height: 150px;">
                                <img [src]="renderImage(props)" alt="Profile-Pic" width="150" height="150"
                                    style="object-fit: cover;">
                            </div>

                        </div>

                    </div>
                </div>

            </div>
            <div class="col-md-3">
                <app-events [showheader]=true></app-events>

            </div>
        </div>
    </div>
</div>
